import { Component, Inject, NgZone } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { faExclamationCircle, faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'error-alert',
  templateUrl: './error-alert.component.html'
})

export class ErrorAlertComponent {

  public faExclamationCircle = faExclamationCircle;
  public faTimes = faTimes;
  public faExclamationTriangle = faExclamationTriangle;
  public message: string = "An unexpected error has occured.";
  public shouldShowCloseButton: boolean = false;
  
  constructor(
    public snackBarRef: MatSnackBarRef<ErrorAlertComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public zoneRef: NgZone) { 
    
    if(data.message) {
      this.message = data.message;
    }
    this.shouldShowCloseButton = data.shouldShowCloseButton;
  }

  public closeErrorAlert(): void {
    this.snackBarRef.dismiss();
  }
}